export default class Feedback extends React.PureComponent
  NUMBER = 10000

  render: ->
    if @props.currentUser?.isPro
      @renderProMessage()
    else
      @renderDefaultMessage()

  renderProMessage: ->
    proMessage = @props.i18n.proMessage
    proMessage = proMessage.replace('%{path}', @props.paths.subscriptionsPath)
    
    <div className="feedback">
      <span dangerouslySetInnerHTML={{ __html: proMessage }} />
    </div>
  
  renderDefaultMessage: ->
    trustedBy = @props.i18n.trustedBy
    trustedBy = trustedBy.replace('%{number}', NUMBER.toLocaleString(@props.currentLocale))
    trustedBy = trustedBy.replace('%{title}', @props.i18n.abbrTitle)

    <div className="feedback">
      <span dangerouslySetInnerHTML={{ __html: trustedBy }} />
      &nbsp;
      <span className="love">
        <i className="fas fa-heart" aria-hidden="true"></i>
      </span>
    </div>
